
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimIndexationProfileDialog extends Serenity.EntityDialog<DimIndexationProfileRow, any> {
        protected getFormKey() { return DimIndexationProfileForm.formKey; }
        protected getIdProperty() { return DimIndexationProfileRow.idProperty; }
        protected getLocalTextPrefix() { return DimIndexationProfileRow.localTextPrefix; }
        protected getService() { return DimIndexationProfileService.baseUrl; }
        protected getDeletePermission() { return DimIndexationProfileRow.deletePermission; }
        protected getInsertPermission() { return DimIndexationProfileRow.insertPermission; }
        protected getUpdatePermission() { return DimIndexationProfileRow.updatePermission; }

        protected form = new DimIndexationProfileForm(this.idPrefix);

    }
}